<template>
    <div class="research-literature">
        <div class="filter-bar">
            <div class="filter-item">
                <span class="filter-label">证据类型</span>
                <el-select size="small" v-model="filters.evidenceType" placeholder="全部" clearable>
                    <el-option
                        v-for="item in evidenceTypeOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                    />
                </el-select>
            </div>
            <div class="filter-item">
                <span class="filter-label">出版年份</span>
                <el-select size="small" v-model="filters.year" placeholder="全部" clearable>
                    <el-option
                        v-for="item in yearOptions"
                        :key="item"
                        :label="String(item)"
                        :value="item"
                    />
                </el-select>
            </div>
            <div class="filter-item">
                <span class="filter-label">发表地</span>
                <el-select size="small" v-model="filters.place" placeholder="全部" clearable>
                    <el-option
                        v-for="item in placeOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                    />
                </el-select>
            </div>
            <div class="filter-item keyword-item">
                <span class="filter-label">关键词</span>
                <el-input size="small"
                    v-model.trim="filters.keyword"
                    placeholder="请输入关键词"
                    clearable
                    @keyup.enter.native="handleSearch"
                />
            </div>
            <div class="filter-actions">
                <el-button size="small" type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                <el-button size="small" type="danger" plain icon="el-icon-refresh-left" @click="handleReset">重置</el-button>
            </div>
        </div>

        <el-table
            class="literature-table"
            :data="pageList"
            :header-cell-style="headerCellStyle"
            stripe
            size="small"
        >
            <el-table-column
                type="index"
                label="序号"
                width="70"
                align="center"
                :index="indexMethod"
            />
            <el-table-column prop="title" label="标题" min-width="260" show-overflow-tooltip />
            <el-table-column prop="author" label="作者" min-width="140" show-overflow-tooltip />
            <el-table-column prop="journal" label="期刊" min-width="160" show-overflow-tooltip />
            <el-table-column prop="year" label="发表年份" width="100" align="center" />
            <el-table-column prop="evidenceLevel" label="证据等级" width="100" align="center" />
            <el-table-column prop="docType" label="文献类型" width="110" align="center" />
            <!-- <el-table-column label="操作" width="120" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" @click="handleDetail(scope.row)">详情</el-button>
                    <el-button type="text" @click="handleReference(scope.row)">参考</el-button>
                </template>
            </el-table-column> -->
        </el-table>

        <el-pagination
            class="page-wrap"
            background
            layout="total, prev, pager, next, jumper"
            :current-page="pageInfo.pageNum"
            :page-size="pageInfo.pageSize"
            :total="pageInfo.total"
            @current-change="changePage"
        />
    </div>
</template>

<script>
const MOCK_LIST = [
    {
        id: 1,
        title: '黄芪内服联合西药对2型糖尿病患者的疗效观察',
        author: '张仲景, 李时珍',
        journal: '中国中医药杂志',
        year: 2023,
        evidenceLevel: '1a',
        docType: 'RCT',
        evidenceType: 'RCT',
        place: '中国',
    },
    {
        id: 2,
        title: '中医药治疗糖尿病肾病的系统评价与Meta分析',
        author: '孙思邈, 华佗',
        journal: '中医杂志',
        year: 2022,
        evidenceLevel: '1b',
        docType: '综述',
        evidenceType: '系统评价',
        place: '中国',
    },
    {
        id: 3,
        title: '针灸干预糖尿病周围神经病变的随机对照试验',
        author: '扁鹊, 张景岳',
        journal: '针刺研究',
        year: 2021,
        evidenceLevel: '2a',
        docType: 'RCT',
        evidenceType: 'RCT',
        place: '中国',
    },
    {
        id: 4,
        title: '糖尿病中医证候分布规律的横断面研究',
        author: '叶天士, 吴鞠通',
        journal: '北京中医药大学学报',
        year: 2020,
        evidenceLevel: '2b',
        docType: '观察',
        evidenceType: '观察性研究',
        place: '中国',
    },
    {
        id: 5,
        title: '人参皂苷对糖尿病大鼠胰岛功能保护作用的实验研究',
        author: '王清任, 朱丹溪',
        journal: '中国实验方剂学杂志',
        year: 2019,
        evidenceLevel: '2a',
        docType: '实验研究',
        evidenceType: '实验研究',
        place: '中国',
    },
    {
        id: 6,
        title: 'Traditional Chinese Medicine for Type 2 Diabetes: A Systematic Review',
        author: 'Li Wei, Chen Ming',
        journal: 'Journal of Ethnopharmacology',
        year: 2023,
        evidenceLevel: '1a',
        docType: 'Meta',
        evidenceType: '系统评价',
        place: '国外',
    },
    {
        id: 7,
        title: '六味地黄丸联合二甲双胍治疗气阴两虚型糖尿病临床观察',
        author: '徐大椿, 陈修园',
        journal: '新中医',
        year: 2018,
        evidenceLevel: '1b',
        docType: 'RCT',
        evidenceType: 'RCT',
        place: '中国',
    },
    {
        id: 8,
        title: '中西医结合治疗糖尿病足溃疡的疗效Meta分析',
        author: '傅青主, 万全',
        journal: '中国中西医结合杂志',
        year: 2022,
        evidenceLevel: '1a',
        docType: 'Meta',
        evidenceType: '系统评价',
        place: '中国',
    },
    {
        id: 9,
        title: '消渴病病因病机古今文献述评',
        author: '程钟龄, 尤在泾',
        journal: '中华中医药杂志',
        year: 2017,
        evidenceLevel: '2b',
        docType: '综述',
        evidenceType: '综述',
        place: '中国',
    },
    {
        id: 10,
        title: '葛根芩连汤改善胰岛素抵抗的分子机制研究',
        author: '柯琴, 汪昂',
        journal: '中草药',
        year: 2021,
        evidenceLevel: '2a',
        docType: '实验研究',
        evidenceType: '实验研究',
        place: '中国',
    },
    {
        id: 11,
        title: '中药复方干预糖尿病视网膜病变的临床疗效观察',
        author: '黄元御, 唐容川',
        journal: '中国中医眼科杂志',
        year: 2020,
        evidenceLevel: '1b',
        docType: 'RCT',
        evidenceType: 'RCT',
        place: '中国',
    },
    {
        id: 12,
        title: '针灸治疗糖尿病胃轻瘫的随机对照研究',
        author: '曹炳章, 丁甘仁',
        journal: '中国针灸',
        year: 2019,
        evidenceLevel: '1b',
        docType: 'RCT',
        evidenceType: 'RCT',
        place: '中国',
    },
    {
        id: 13,
        title: 'Herbal Medicine and Glycemic Control: An Observational Cohort Study',
        author: 'Wang Fang, Zhao Lei',
        journal: 'Complementary Therapies in Medicine',
        year: 2022,
        evidenceLevel: '2b',
        docType: '观察',
        evidenceType: '观察性研究',
        place: '国外',
    },
    {
        id: 14,
        title: '糖尿病中医诊疗指南更新要点解读',
        author: '仝小林, 吕仁和',
        journal: '中医杂志',
        year: 2023,
        evidenceLevel: '2a',
        docType: '综述',
        evidenceType: '综述',
        place: '中国',
    },
    {
        id: 15,
        title: '丹参注射液对糖尿病心肌病变保护作用的实验研究',
        author: '施今墨, 蒲辅周',
        journal: '中国中药杂志',
        year: 2018,
        evidenceLevel: '2a',
        docType: '实验研究',
        evidenceType: '实验研究',
        place: '中国',
    },
];

const EMPTY_FILTERS = {
    evidenceType: '',
    year: '',
    place: '',
    keyword: '',
};

export default {
    name: 'ResearchLiterature',
    data() {
        return {
            filters: { ...EMPTY_FILTERS },
            appliedFilters: { ...EMPTY_FILTERS },
            evidenceTypeOptions: ['RCT', '系统评价', '观察性研究', '实验研究', '综述'],
            yearOptions: [2023, 2022, 2021, 2020, 2019, 2018, 2017],
            placeOptions: ['中国', '国外'],
            allList: MOCK_LIST,
            pageInfo: {
                pageNum: 1,
                pageSize: 10,
                total: 0,
            },
            headerCellStyle: {
                background: '#F5F7FA',
                color: '#303133',
                fontWeight: 'bold',
            },
        };
    },
    computed: {
        filteredList() {
            const { evidenceType, year, place, keyword } = this.appliedFilters;
            return this.allList.filter((item) => {
                if (evidenceType && item.evidenceType !== evidenceType) return false;
                if (year && item.year !== year) return false;
                if (place && item.place !== place) return false;
                if (keyword) {
                    const text = [
                        item.title,
                        item.author,
                        item.journal,
                        item.docType,
                        item.evidenceLevel,
                    ].join(' ');
                    if (!text.includes(keyword)) return false;
                }
                return true;
            });
        },
        pageList() {
            const { pageNum, pageSize } = this.pageInfo;
            const start = (pageNum - 1) * pageSize;
            return this.filteredList.slice(start, start + pageSize);
        },
    },
    watch: {
        filteredList: {
            immediate: true,
            handler(list) {
                this.pageInfo.total = list.length;
                const maxPage = Math.max(1, Math.ceil(list.length / this.pageInfo.pageSize) || 1);
                if (this.pageInfo.pageNum > maxPage) {
                    this.pageInfo.pageNum = maxPage;
                }
            },
        },
    },
    methods: {
        indexMethod(index) {
            return (this.pageInfo.pageNum - 1) * this.pageInfo.pageSize + index + 1;
        },
        handleSearch() {
            this.appliedFilters = { ...this.filters };
            this.pageInfo.pageNum = 1;
        },
        handleReset() {
            this.filters = { ...EMPTY_FILTERS };
            this.appliedFilters = { ...EMPTY_FILTERS };
            this.pageInfo.pageNum = 1;
        },
        changePage(page) {
            this.pageInfo.pageNum = page;
        },
        handleDetail(row) {
            this.$message.info(`查看详情：${row.title}`);
        },
        handleReference(row) {
            this.$message.success(`已加入参考：${row.title}`);
        },
    },
};
</script>

<style lang="less" scoped>
.research-literature {
    .filter-bar {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 12px 16px;
        margin-bottom: 16px;
    }

    .filter-item {
        display: flex;
        align-items: center;

        .filter-label {
            margin-right: 8px;
            font-size: 14px;
            color: #303133;
            white-space: nowrap;
        }

        .el-select {
            width: 140px;
        }

        &.keyword-item .el-input {
            width: 200px;
        }
    }

    .filter-actions {
        display: flex;
        align-items: center;
        gap: 8px;

        .el-button--primary {
            background: #165DFF;
            border-color: #165DFF;
        }
    }

    .literature-table {
        width: 100%;

        ::v-deep .el-button--text {
            color: #165DFF;
            padding: 0 4px;
        }
    }

    .page-wrap {
        margin-top: 16px;
        text-align: right;
    }
}
</style>
